import React, { useState, useEffect } from 'react';
import { IonButton, IonModal, IonGrid } from '@ionic/react';
import './LogoutPopup.scss';
import { useTranslation } from 'react-i18next';

export const LogoutPopUp: React.FC<any> = (props) => {
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(props.showLogoutModal);
  useEffect(() => {
    setShowModal(props.showLogoutModal);
  }, [props.showLogoutModal]);
  return (
    <IonModal isOpen={showModal} cssClass="dropdown-modal">
      <div className="logout_modalPopUp" data-testid ="logout_modalPopUp">
        <IonGrid class="popup-header"> {t('Logout')} </IonGrid>
        <IonGrid class="popup-body">
          <p className="modalPopUp_text">
            {props.isRegistrationPage
              ? t('REGISTRATION_ALERT_MESSAGE')
              : t('ALERT_MESSAGE')}
          </p>
          <div className="button-div">
          <IonButton
              className="secondary-cta-btn-mobile mr"
              data-testid="logout-click"
              onClick={props.logOut}
            >
              {t('Logout')}
            </IonButton>
            <IonButton
              className="primary-cta-btn-mobile"
              onClick={props.closeShowModal}
              data-testid="logout-close"
            >
              {t('Cancel')}
            </IonButton>
          </div>
        </IonGrid>
      </div>
    </IonModal>
  );
};
